import React, { Fragment } from 'react';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import AdditionalInformationSummary from './pageIncludes/summary/AdditionalInformationSummary';
import PageHeader from '../headers/PageHeader';

// Selectors

import { selectIfRenewalFlow } from '@reducers/appReducer';



/**
 *
 * @param {Object} props
 * @returns {React.Component} - Summary page for 'Family and Household' Section
 *
 */
const Page4_64  = props => {

    const {
        adjustedFlow,
        allStatuses,
        data,
        environment: {
            isState,
            stateCode,
            localDates: {
                serverDate
            }
        },
        householdMembers,
        taxHousehold
    } = props;

    const {
        alwaysDisplayMedicaidQuestions,
        buttonContainer,
        inlineCurrentIncomeEnabled,
        itfFeatureEnabled,
    } = props;

    const isRenewalFlow = useSelector(selectIfRenewalFlow);

    return (
        <Fragment>
            <div id="fhSummary" className="fade-in ">
                <div className="subsection">
                    <PageHeader
                        text='ssap.subheader.review_and_confirm'
                        headerClassName={'gi-heading-alt'}
                    />
                    <div className="grid-row">
                        <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__info alert__review">
                            <div className="gi-alert__body">
                                <p className="gi-alert__text">
                                    <FormattedMessage 
                                        id='ssap.additional_info.summary.notification'
                                        values={{
                                            strong: chunks => <strong>{chunks}</strong>
                                        }}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div  className="grid-row">
                        <AdditionalInformationSummary
                            {...{
                                adjustedFlow,
                                allStatuses,
                                alwaysDisplayMedicaidQuestions,
                                buttonContainer,
                                householdMembers,
                                inlineCurrentIncomeEnabled,
                                isRenewalFlow,
                                isState,
                                stateCode,
                                itfFeatureEnabled,
                                previousData: data,
                                serverDate,
                                taxHousehold
                            }}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,

    adjustedFlow: state.ssap.adjustedFlow,
    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember,

    taxHousehold: state
        .ssap
        .data
        .taxHousehold
});

export default connect(mapStateToProps)(Page4_64);
